var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"16/x"},React.createElement("path",{"id":"Vector","d":"M16.9999 16.9999L12 12M12 12L7 7M12 12L17 7M12 12L7 17","stroke":"#7A7A7A","strokeWidth":"1.5","strokeLinecap":"square","strokeLinejoin":"round"})));
}

X.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = X;

X.default = X;
